import { StepType } from '@de/types/enums';
import type { DCS, Step } from '@de/types/types';
import { getStepGrainToken } from '@de/utils/stepGrain';

// Port of Supersonic's `getExperienceVariant`: `<stepGrain>-<slotVariant>` for a
// personalized DCS step with a Monarch asset, else `<stepGrain>-default`. `''`
// when there's no resolvable grain (vs Supersonic's `undefined-default`).
export const getExperienceVariant = (
  currentStepType: string | undefined,
  currentStep: Step | undefined,
  slotVariant?: string,
): string => {
  if (!currentStepType) return '';

  const experienceType = getStepGrainToken(currentStepType, currentStep);

  if (!experienceType) return '';

  const isPersonalizedDcs =
    currentStepType === StepType.DCS &&
    (currentStep as DCS)?.variant === 'personalized';

  return slotVariant && isPersonalizedDcs
    ? `${experienceType}-${slotVariant}`
    : `${experienceType}-default`;
};
